<template>
    <div id="mail-list">
        <div>
            <div class="header">
                <a-input-search
                    v-model:value="searchValue"
                    :placeholder="$t('message.query')"
                    style="width: 100% !important"
                    @input="onSearch($event)"
                />
                <div class="toolbar">
                    <div class="tabs">
                        <a-tooltip
                            placement="top"
                            :title="$t('message.all')"
                            class="item"
                            :class="[selected === 'all' && 'selected']"
                            @click="mailListAll"
                        >
                            <span class="material-icons filter-icons">all_inbox</span>
                            <span class="count">{{ allMailCounts }}</span>
                        </a-tooltip>
                        <a-tooltip
                            placement="top"
                            :title="$t('mail.unread')"
                            class="item"
                            :class="[selected === 'unread' && 'selected']"
                            @click="mailListUnread('')"
                            v-if="selectedMenu === 'My'"
                        >
                            <span class="material-icons filter-icons">mark_email_unread</span>
                            <span class="count">{{ unreadMailCount }}</span>
                        </a-tooltip>
                        <a-tooltip
                            placement="top"
                            :title="$t('mail.unreply')"
                            class="item"
                            :class="[selected === 'unreply' && 'selected']"
                            @click="getUnReplyMails('')"
                            v-if="selectedMenu === 'My'"
                        >
                            <span class="material-icons filter-icons">unsubscribe</span>
                            <span class="count" v-if="unReplyMailCount > 0">{{ unReplyMailCount }}</span>
                        </a-tooltip>
                    </div>
                    <div class="actions">
                        <span class="material-icons" style="font-size: 20px; cursor: pointer" @click="refresh"
                            >replay</span
                        >
                        <a-popover id="mail-multi-btn" placement="bottom" trigger="click" v-if="selectedMenu === 'My'">
                            <md-icon style="cursor: pointer">more_horiz</md-icon>
                            <div slot="content">
                                <div class="mail-detail" @click="markAsRead()">
                                    <span class="material-icons">mark_email_read</span>
                                    <span class="mail-detail-item">{{ $t("mail.markAsRead") }}</span>
                                </div>
                            </div>
                        </a-popover>
                    </div>
                </div>
            </div>
            <md-progress-bar class="md-accent" :md-mode="isDeterminate"></md-progress-bar>
            <NoMessage v-if="filterMailList.length === 0" :desc="$t('mail.mailNotFound')" />
            <div v-else class="mails">
                <div v-for="email of filterMailList">
                    <div
                        class="item"
                        :class="[selectedMailThreadId === email.thread_id && 'selected']"
                        @click="changeSelectedMail(email.thread_id)"
                    >
                        <!--                        <span-->
                        <!--                            class="unread-circle"-->
                        <!--                            v-if="(!!email.isUnread && email.isUnread.length > 0) || selected === 'unread'"-->
                        <!--                        ></span>-->
                        <div class="avatar">
                            <span class="avatar-name">{{
                                email.sender ? email.sender.slice(0, 1).toUpperCase() : ""
                            }}</span>
                        </div>
                        <div class="metas">
                            <div class="left">
                                <a-tooltip :title="email.sender">
                                    <div class="name">
                                        {{
                                            email.sender.length > 15
                                                ? email.sender.substring(0, 30) + "..."
                                                : email.sender
                                        }}
                                    </div>
                                </a-tooltip>
                                <div class="subject">
                                    <span class="subject-name">{{ $t("headBar.subject") }}: </span>
                                    <span>{{ email.subject }}</span>
                                </div>
                                <!--                                <div class="body">-->
                                <!--                                    <span class="content-name">{{ $t("message.content") }}: </span>-->
                                <!--                                    <span>{{ email.body_text }}</span>-->
                                <!--                                </div>-->
                            </div>
                            <div class="right">{{ getTime(email.created_at) }}</div>
                        </div>
                    </div>
                </div>
                <div class="material-icons get-mails" @click="getLoadMore" v-if="isVisibleLoadMore()">
                    add_circle_outline
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { log2 } from "../../../utils/log2";
import NoMessage from "./NoMessage.vue";
import { MAIL_API } from "../../../api/mail";
import moment from "moment";
import _ from "lodash";

const log = log2("MailList");
export default {
    name: "MailList",
    components: { NoMessage },
    props: {
        isRefresh: Number,
    },
    data() {
        return {
            selected: "all",
            searchValue: "",
            pageCount: 1,
            perPage: 20,
            isDeterminate: "determinate",
            filterMailList: [],
            allMailCounts: 0,
            isSearchValueEmpty: true,
            mailDetails: [],
            unReplyMailCount: 0,
            unreadMailCount: 0,
        };
    },
    computed: {
        ...mapState({
            selectedMailThreadId: (state) => state.mail.selectedMailThreadId,
            selectedMenu: (state) => state.mail.selectedMenu,
            selectedDepartment: (state) => state.mail.selectedDepartment,
            allMailAddresses: (state) => state.mail.allMailAddresses,
            selectedRepresentativeInfo: (state) => state.mail.selectedRepresentativeInfo,
            user: (state) => state.auth.user,
            selectedMailId: (state) => state.mail.selectedMailId,
        }),
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({
            getMailListAction: "mail/getMailList",
            getMailDetails: "mail/getMailDetails",
            cleanUnreadThread: "mail/cleanUnreadThread",
            cleanAllUnreadThread: "mail/cleanAllUnreadThread",
            getAllUnreadMailCount: "mail/getAllUnreadMailCount",
        }),
        ...mapMutations({
            SELECTED_MAIL: "mail/SELECTED_MAIL",
        }),
        getTime(date) {
            return moment(date).format("DD.MM.YYYY HH:mm");
        },
        isVisibleLoadMore() {
            if (this.selected !== "unreply") return this.filterMailList.length !== this.unReplyMailCount;
            else if (this.selected !== "unread") return this.filterMailList.length !== this.unreadMailCount;
            else return this.filterMailList.length !== this.allMailCounts;
        },
        async markAsRead() {
            await this.cleanAllUnreadThread(this.user._id);
            await this.getAllUnreadMailCount(this.user._id);
        },
        async onSearch(e) {
            this.isSearchValueEmpty = e.target.value.length === 0;
            if (this.selectedMenu === "My" && this.selected === "unreply") this.getUnReplyMails(e.target.value);
            else if (this.selectedMenu === "My" && this.selected === "unread") this.mailListUnread(e.target.value);
            else
                this.filterMailList = await this.getMailList(
                    this.selectedMenu === "My",
                    this.pageCount,
                    this.perPage,
                    e.target.value !== "" ? e.target.value : ""
                );
        },
        async mailListAll() {
            this.pageCount = 1;
            this.selected = "all";
            this.filterMailList = await this.getMailList(this.selectedMenu === "My");
        },
        getUnReplyMails(searchValue = "", pageCount = "") {
            if (pageCount === "") this.pageCount = 1;
            else this.pageCount = pageCount;
            this.selected = "unreply";
            let mailAddress = this.getMailAddress();
            this.$emit("loading", true);
            MAIL_API.getUnReplyMails({
                userId: this.user._id,
                mailAddress,
                pageCount: this.pageCount,
                perPage: this.perPage,
                searchValue,
            }).then((res) => {
                this.unReplyMailCount = res.count || 0;
                const list = _.get(res, "mails", []);
                if (pageCount !== "") this.filterMailList = [...this.filterMailList, ...list];
                else this.filterMailList = list;
                this.$emit("loading", false);
            });
        },
        mailListUnread(searchValue = "", pageCount = "") {
            if (pageCount === "") this.pageCount = 1;
            else this.pageCount = pageCount;
            this.selected = "unread";
            const mailAddress = this.getMailAddress();
            this.$emit("loading", true);
            MAIL_API.getUnreadMails({
                userId: this.user._id,
                mailAddress,
                pageCount: this.pageCount,
                perPage: this.perPage,
                searchValue,
            }).then((res) => {
                console.log("getUnreadMails res..", res);
                this.unreadMailCount = _.get(res, "count", 0);
                const list = _.get(res, "mails", []);
                if (pageCount !== "") this.filterMailList = [...this.filterMailList, ...list];
                else this.filterMailList = list;
                this.$emit("loading", false);
            });
        },
        getName(email) {
            if (!!email.ref_visitor_id) {
                return email.ref_visitor_id.email;
            } else {
                return this.selectedMenu === "My" ? email.sender : email.to_list[0];
            }
        },
        async changeSelectedMail(threadId) {
            console.log("changeSelectedMail worked..", threadId);
            this.SELECTED_MAIL(threadId);
            await this.getMailDetail(threadId);
        },
        async getMailDetail(threadId) {
            console.log("getMailDetail worked..");
            if (!!threadId) {
                this.$emit("loading", true);
                this.mailDetails = await this.getMailDetails(threadId);
                this.$emit("loading", false);
                await this.cleanUnreadThread({ userId: this.user._id, threadId });
                this.getAllUnreadMailCount(this.user._id);
            }
        },
        getMailAddress() {
            if (this.selectedMenu === "department") {
                return this.selectedDepartment;
            } else {
                if (!!this.allMailAddresses) {
                    const mailId = this.selectedMailId
                        ? this.selectedMailId
                        : this.allMailAddresses.find((mail) => mail.user._id === this.user._id && mail.isDefault)._id;
                    return this.allMailAddresses.filter((email) => email._id === mailId)[0].mail;
                }
            }
        },
        async getMailList(incoming, pageCount = this.pageCount, perPage = this.perPage, searchValue = "", mail = null) {
            console.log("getMailList worked", {
                incoming,
                pageCount,
                perPage,
                searchValue,
                mail,
            });
            let mailAddress;
            if (mail) mailAddress = mail;
            else mailAddress = this.getMailAddress();
            this.$emit("loading", true);
            const response = await this.getMailListAction({
                incoming,
                userId: this.user._id,
                mailAddress,
                pageCount,
                perPage,
                searchValue,
            });
            this.allMailCounts = response.count || 0;
            this.unReplyMailCount = response.unReplyCount || 0;
            this.unreadMailCount = response.unreadCount || 0;
            this.$emit("loading", false);
            return _.get(response, "mails", []);
        },
        refresh() {
            this.pageCount = 1;
            this.searchValue = "";
            console.log("REFRESH ..getMailsByType");
            this.getMailsByType();
        },
        async getLoadMore() {
            this.pageCount += 1;
            this.isDeterminate = "indeterminate";
            if (this.selectedMenu === "My" && this.selected === "unreply") this.getUnReplyMails("", this.pageCount);
            else if (this.selectedMenu === "My" && this.selected === "unread") this.mailListUnread("", this.pageCount);
            else {
                const result = await this.getMailList(this.selectedMenu === "My");
                this.filterMailList = [...this.filterMailList, ...result];
            }
            this.isDeterminate = "determinate";
        },
        async getMailsByType() {
            console.log("getMailsByType worked", {
                selectedMenu: this.selectedMenu,
                selected: this.selected,
            });
            this.pageCount = 1;
            if (this.selectedMenu === "My" && this.selected === "unreply") this.getUnReplyMails("");
            else if (this.selectedMenu === "My" && this.selected === "unread") this.mailListUnread("");
            else if (this.selectedMenu === "department") {
                this.filterMailList = await this.getMailList(false);
            } else {
                this.filterMailList = await this.getMailList(this.selectedMenu === "My");
            }
            this.$message.destroy();
            // if (this.filterMailList.length > 0) await this.getMailDetail(this.filterMailList[0].thread_id);
            // else this.mailDetails = [];
        },
    },
    async mounted() {
        this.getMailsByType();
        console.log("mounted filterMailList..", this.filterMailList);

        if (this.filterMailList.length > 0) this.SELECTED_MAIL(this.filterMailList[0].thread_id);

        this.intervalId = setInterval(async () => {
            if (!!this.isSearchValueEmpty && (this.selectedMenu !== "" || this.selectedDepartment !== "")) {
                this.isDeterminate = "indeterminate";
                if (this.selectedMenu === "My" && this.selected === "unreply") this.getUnReplyMails("");
                if (this.selectedMenu === "My" && this.selected === "unread") this.mailListUnread("");
                else {
                    this.filterMailList = await this.getMailList(
                        this.selectedMenu === "My",
                        1,
                        this.pageCount * this.perPage
                    );
                }
                this.isDeterminate = "determinate";
            }
        }, 60 * 1000);
    },
    beforeDestroy() {
        clearInterval(this.intervalId);
    },
    watch: {
        async mailDetails(val) {
            console.log("MailList watch worked mailDetails");
            this.$emit("mailDetails", val);
        },
        isRefresh() {
            console.log("MailList watch worked isRefresh");
            this.getMailsByType();
        },
        // async selectedMailThreadId(val) {
        //     console.log("MailList watch worked selectedMailThreadId");
        //     await this.getMailDetail(val);
        // },
        allMailAddresses(val) {
            console.log("MailList watch worked allMailAddresses");
            if (val.length > 0 && this.filterMailList.length === 0) {
                this.getMailsByType();
            }
        },
        selectedMailId(val) {
            console.log("MailList watch worked selectedMailId");
            this.getMailsByType();
        },
        selectedDepartment(val) {
            console.log("MailList watch worked selectedDepartment");
            if (this.selectedMenu === "department" && this.selectedMenu !== "") {
                this.getMailsByType();
            }
        },
        async selectedRepresentativeInfo(val) {
            console.log("MailList watch worked selectedRepresentativeInfo");
            this.pageCount = 1;
            this.$message.loading("Mesajler yükleniyor");
            this.filterMailList = await this.getMailList(
                this.selectedMenu === "My",
                this.pageCount,
                this.perPage,
                "",
                val.mailAddress
            );
            this.$message.destroy();
            // if (this.filterMailList.length > 0) await this.getMailDetail(this.filterMailList[0].thread_id);
            // else this.mailDetails = [];
        },
        selectedMenu(val) {
            console.log("MailList watch worked selectedMenu");
            if (val !== "department" && val !== "") {
                this.getMailsByType();
            }
        },
    },
};
</script>

<style lang="scss">
#mail-list {
    max-width: 400px;
    flex: 0 0 400px;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #c7d0d7;

    .ant-popover-inner-content {
        padding: 5px 5px 3px 5px;
    }

    .md-accent {
        background: #bfeadb;

        .md-progress-bar-fill::after {
            background-color: #009688 !important;
        }

        .md-progress-bar-track::after {
            background-color: #009688 !important;
        }
    }

    .header {
        display: flex;
        padding: 13px 20px 3px;
        margin-bottom: 5px;
        grid-gap: 5px;
        flex-flow: column;
        max-height: 116px;

        .toolbar {
            display: flex;
            justify-content: space-between;
            grid-gap: 10px;
            gap: 10px;
            align-items: center;
            padding-top: 5px;

            .tabs {
                display: flex;
                grid-gap: 5px;
                gap: 5px;

                .item {
                    padding: 5px;
                    cursor: pointer;
                    display: flex;
                    gap: 5px;
                    align-items: center;
                    box-shadow: none;
                    font-size: 14px;
                    font-weight: 600;
                    letter-spacing: -0.24px;
                    line-height: 24px;
                    border-radius: 4px;

                    &.selected {
                        background-color: #c7d0d7;
                        color: #5a5f72;
                    }

                    .count {
                        display: inline-block;
                        font-size: 11px;
                        font-weight: 700;
                        line-height: 16px;
                        padding: 0 4px;
                        border-radius: 4px;
                        height: fit-content;
                        background: #fff;
                        min-width: fit-content;
                    }

                    .filter-icons {
                        font-size: 20px;
                    }
                }
            }
        }

        .actions {
            .mail-detail {
                cursor: pointer;
                display: flex;
                align-items: center;
                margin-bottom: 5px;

                .mail-detail-item {
                    margin-left: 5px;
                }

                &:hover {
                    background-color: #edf1f4;
                    padding: 3px 5px 3px 5px !important;
                }
            }
        }
    }

    .mails {
        overflow-x: hidden;
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        max-width: 100%;
        width: 100%;
        height: calc(100vh - 200px);

        .get-mails {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 10px;
            font-size: 35px;
            cursor: pointer;
        }

        .item {
            display: flex;
            align-items: center;
            position: relative;
            margin-right: 1px;
            border: none;
            border-radius: 0;
            padding: 16px;
            cursor: pointer;
            grid-gap: 5px;
            gap: 5px;
            border-bottom: 1px solid #c7d0d7;

            &:hover {
                background-color: #edf1f4;
            }

            &.selected {
                background-color: #d1ecde6e;
                border-left: 4px solid #009688;
            }

            .unread-circle {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: #009688;
            }

            .avatar {
                vertical-align: middle;
                width: 30px;
                height: 30px;
                border-radius: 25px;
                font-family: Helvetica, Arial, sans-serif;
                background-color: #8d5cc6;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 5px;

                .avatar-name {
                    font-size: large;
                    color: white;
                    font-weight: 500;
                }
            }
        }

        .metas {
            display: flex;
            justify-content: space-between;
            width: 90%;

            .left {
                display: flex;
                flex-direction: column;
                max-width: 50%;
                display: flex;
                flex-flow: wrap;

                .name {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    width: 200px;
                    font-weight: 600;
                    font-size: 14px;
                }

                .subject {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    width: 220px;
                    font-size: 12px;
                    font-weight: 400;

                    .subject-name {
                        font-weight: 600;
                    }
                }

                .body {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-size: 12px;
                    font-weight: 400;
                    width: 200px;

                    .content-name {
                        font-weight: 600;
                    }
                }
            }

            .right {
            }
        }
    }
}
</style>
